import { countriesList, statesList } from './countries';
import { monthsArray, weekDaysArray } from './dates';

export const constants = {
  monthsArray,
  weekDaysArray,
  countriesList,
  statesList,
};
